import { render } from "./InputText.vue?vue&type=template&id=1a4cb16c"
import script from "./InputText.vue?vue&type=script&lang=js"
export * from "./InputText.vue?vue&type=script&lang=js"

import "./InputText.vue?vue&type=style&index=0&id=1a4cb16c&lang=scss"
script.render = render

export default script